<template>
  <div style="margin: 4px">
    <slot/>
    <img :src="getSrc"/>
  </div>
</template>
<script>
  export default {
    props: {
      src: String,
    },
    computed: {
      getSrc() {
        const date = new Date();
        const timestamp = date.getTime();
        return this.src + "?" + timestamp;
      },
    },
  }

</script>
